import * as React from 'react';
import * as styles from './styles.css';

import cn from 'clsx';

import { ArticleParagraph2 } from '@cian/ui-kit';

export interface IValuationReadyProps {
  isDesktop: boolean;
  onClick(): void;
}

export const ValuationReady: React.FC<IValuationReadyProps> = ({ isDesktop, onClick }) => {
  return (
    <div className={cn(styles['container'], isDesktop ? styles['container_desktop'] : styles['container_mobile'])}>
      <ArticleParagraph2>Кажется, вы уже оценивали эту квартиру.</ArticleParagraph2>
      <div className={styles['link-wrapper']}>
        <div data-testid="valuation_ready_button" className={styles['link']} onClick={onClick}>
          Перейти к оценке
        </div>
      </div>
    </div>
  );
};

ValuationReady.displayName = 'ValuationReady';
